import { Type } from "@sinclair/typebox";
import SchemaValidator from "../../../schema-validator";

const tabCloseOneEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("tab"),
		name: Type.Literal("close one"),
		time: Type.Date(),
		details: Type.Object({
			url: Type.String(),
			title: Type.String(),
			autoClose: Type.Boolean(),
		}),
	}),
);

const tabCreateEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("tab"),
		name: Type.Literal("create"),
		time: Type.Date(),
		details: Type.Object({
			url: Type.String(),
			title: Type.String(),
		}),
	}),
);

const tabWhitelistEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("tab"),
		name: Type.Literal("whitelist"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
			whiteList: Type.Array(Type.String()),
		}),
	}),
);

const tabDisableEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("tab"),
		name: Type.Literal("disable"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
		}),
	}),
);

const tabFocusEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("tab"),
		name: Type.Literal("focus"),
		time: Type.Date(),
		details: Type.Object({
			focus: Type.Boolean(),
		}),
	}),
);

export default {
	tabCloseOneEvent,
	tabCreateEvent,
	tabWhitelistEvent,
	tabDisableEvent,
	tabFocusEvent,
};
